import { Image } from '../../../services/shared/shared-interface';
export interface RolesPermissions {
  state: RolesPermissionsState;
}
export interface RolesPermissionsState {
  foo: 'bar';
}

export interface RoleData {
  aemPageLabels: RolePermissionLabel;
  rolesData: Role[];
}

export interface RolePermissionLabel {
  pageHeading: string;
  roleListLabel: string;
  permissionLabel: string;
  detailHeading: string;
  addRole: string;
  removeRole: string;
  copyRole: string;
  roleName: string;
  description: string;
  saveChangesBtnText: string;
  unselectAllText: string;
  duplicateRoleNameErrorText: string;
  customRoleDefaultDescription: string;
  customRoleDefaultName: string;
  unSelectAllLabel: string;
	duplicateRoleErrorText: string;
	defaultRoleName: string;
	defaultRoleDescription: string;
	roleNameValidationError: string;
	toggleOffAltText: string;
	toggleOnAltText: string;
	toggleOffDisabledAltText: string;
	toggleOnDisabledAltText: string;
  deleteConfirmation:{
    headingMain: string;
    headingSub: string;
    manageLabel: string;
    cancel:string;
    removeRole: string;
    users: string;
  }[];
  ellipsesIcon: Image;
  addRoleIcon: Image;
  removeRoleIcon: Image;
  userIcon: Image;
  closeIcon: Image;
  permissionLabels: Permission[];
}

export interface Role {
  id?: string;
  name: string;
  description: string;
  permissions: string[];
  company?: string;
  locked?: boolean;
  action?: string;
  isInvalidText?: boolean;
}

export interface RoleAdd {
  id?: string;
  name: string;
  description: string;
  permissions: string[];
  company: string;
  locked: boolean;
}
export interface Permission {
  categoryGroup: string | string[];
  sectionHeader: string;
  permissionArr: PermissionData[];
}
export interface PermissionData {
  permissionKey: string;
  permissionDescription: string;
  permissionShortDescription: string;
  permissionId: string;
}

export interface RemoveRoleModalState {
  description: string;
  popupHeading: string;
  manageUserText: string;
  cancelBtnText: string;
  users: string;
  removeBtnText: string;
  userCount: number;
  defaultUserRole?: string;
}

export interface DeleteResponse {
  totalUsersAffected: number;
  message: string;
  status: string;
}

export interface RolesPermissionsPayload {
  company: string;
}
